import { BlockComponent } from '~/lib/storyblok'
import { blocks } from '~/storyblok/blocks'
import type { Location } from './types'
import { Intro, Container, BackButton } from '~/components'

import * as styles from './Location.css'

type Props = {
  story: Location
}

export function Location({ story }: Props) {
  return (
    <>
      <div className={styles.intro}>
        <Intro title={story.name} />
      </div>
      <Container>
        <div className={styles.back}>
          <BackButton>zurück</BackButton>
        </div>
      </Container>
      {story.blocks?.map((block) => (
        <BlockComponent block={block} blocks={blocks} key={block.id} parentContentType="Event" />
      ))}
    </>
  )
}
